var l = Object.defineProperty;
var h = (s, e, t) => e in s ? l(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var n = (s, e, t) => h(s, typeof e != "symbol" ? e + "" : e, t);
import { c as o } from "./exports-xpZYqD67.js";
import { jsx as d } from "react/jsx-runtime";
import { createContext as u, useMemo as S, useContext as b } from "react";
const c = 2e3;
class k {
  constructor(e) {
    n(this, "channelUrl", "");
    n(this, "socket", null);
    n(this, "openedSubscribers", /* @__PURE__ */ new Set());
    n(this, "closedSubscribers", /* @__PURE__ */ new Set());
    n(this, "errorSubscribers", /* @__PURE__ */ new Set());
    n(this, "messageSubscribers", /* @__PURE__ */ new Map());
    n(this, "initSocket", () => {
      console.log("Channel: initSocket()"), this.socket && (this.socket.removeEventListener("open", this.handleSocketOpened), this.socket.removeEventListener("close", this.handleSocketClosed), this.socket.removeEventListener("error", this.handleSocketError), this.socket.removeEventListener("message", this.handleIncomingMessage), this.socket.close()), this.socket = new WebSocket(this.channelUrl), this.socket.addEventListener("open", this.handleSocketOpened), this.socket.addEventListener("close", this.handleSocketClosed), this.socket.addEventListener("error", this.handleSocketError), this.socket.addEventListener("message", this.handleIncomingMessage);
    });
    n(this, "handleSocketOpened", () => {
      console.log("Channel: channel connected."), this.openedSubscribers.forEach((e) => e());
    });
    n(this, "handleSocketClosed", (e) => {
      console.error(
        "Channel: channel closed, attempting to reconnect...",
        e.reason
      ), o(e), this.closedSubscribers.forEach((t) => t()), setTimeout(() => {
        this.initSocket();
      }, c);
    });
    n(this, "handleSocketError", (e) => {
      console.error("Channel: channel error, attempting to reconnect...", e), o(e), this.errorSubscribers.forEach((t) => t()), setTimeout(() => {
        this.initSocket();
      }, c);
    });
    n(this, "handleIncomingMessage", (e) => {
      const t = JSON.parse(e.data).data;
      console.log("Channel: handleIncomingMessage()", t), this.messageSubscribers.forEach((r, i) => {
        i === t.event_type && r(t);
      });
    });
    this.channelUrl = e;
  }
  sendMessage(e) {
    var t;
    (t = this.socket) == null || t.send(JSON.stringify(e));
  }
  subscribe(e) {
    switch (e.event_type) {
      case "open":
        return this.openedSubscribers.add(e.callback);
      case "close":
        return this.closedSubscribers.add(e.callback);
      case "error":
        return this.openedSubscribers.add(e.callback);
      default:
        return this.messageSubscribers.set(
          e.event_type,
          e.callback
        );
    }
  }
  unsubscribe(e) {
    switch (e.event_type) {
      case "open":
        return this.openedSubscribers.delete(e.callback);
      case "close":
        return this.closedSubscribers.delete(e.callback);
      case "error":
        return this.openedSubscribers.delete(e.callback);
      default:
        return this.messageSubscribers.delete(e.event_type);
    }
  }
  get isOpen() {
    var e;
    return ((e = this.socket) == null ? void 0 : e.readyState) === WebSocket.OPEN;
  }
  get isClosed() {
    return this.socket ? this.socket.readyState === WebSocket.CLOSED : !0;
  }
  get isClosing() {
    var e;
    return ((e = this.socket) == null ? void 0 : e.readyState) === WebSocket.CLOSING;
  }
  get isConnecting() {
    var e;
    return ((e = this.socket) == null ? void 0 : e.readyState) === WebSocket.CONNECTING;
  }
  get readyState() {
    var e;
    return (e = this.socket) == null ? void 0 : e.readyState;
  }
}
const a = u({});
function p({
  channelUrl: s,
  children: e,
  isAuthenticated: t
}) {
  const r = S(() => ({
    channel: t && s ? new k(s) : void 0
  }), [s, t]);
  return /* @__PURE__ */ d(a.Provider, { value: r, children: e });
}
function v() {
  return b(a);
}
const O = (s) => ({
  event_type: "CONVERSATION",
  data: {
    event_type: "CREATE_MESSAGE",
    data: s
  }
});
export {
  k as Channel,
  p as ChannelProvider,
  O as createMessageEvent,
  v as useChannel
};
//# sourceMappingURL=channel.js.map
